import {Component, Input, OnDestroy, OnInit} from '@angular/core';

import { LabOrder } from '../../shared/data/lab-order';
import { LabOrderBusinessService } from '../../shared/lab-order-business.service';
import { ReferenceListItem } from '../../shared/data/reference-list-item';
import { LabOrderReferenceApiService, REF_LIST } from '../../shared/lab-order-reference-api.service';
import {SubscriptionsContainer} from '../../shared/subscriptions-container';

@Component({
  selector: 'app-frame',
  templateUrl: './frame.component.html',
  styleUrls: ['./frame.component.css']
})
export class FrameComponent implements OnInit, OnDestroy {

  @Input() labOrder: LabOrder;

  frameShapes: ReferenceListItem[];
  frameMaterialTypes: ReferenceListItem[];
  frameSuppliedByTypes: ReferenceListItem[];
  subs = new SubscriptionsContainer();

  constructor(
    private labOrderBusinessService: LabOrderBusinessService
  ) { }

  ngOnInit(): void {

    // get the reference lists to populate the drop-downs in the bevel section.
    this.subs.add = this.labOrderBusinessService
      .getReferenceListsByNames([REF_LIST.SHAPES, REF_LIST.FRAME_MATERIAL_TYPES, REF_LIST.FRAME_SUPPLIED_BY])
      .subscribe(
        (data) => {
          this.frameShapes = this.labOrderBusinessService.prettifyRefList(data[0],
            this.labOrderBusinessService.getNewEmptyReferenceListItem());
          this.frameMaterialTypes = this.labOrderBusinessService.prettifyRefList(data[1]);
          this.frameSuppliedByTypes = this.labOrderBusinessService.prettifyRefList(data[2]);
        },
        (error) => {
          this.frameShapes = null;
          this.frameMaterialTypes = null;
          this.frameSuppliedByTypes = null;
          console.log('Did not retrieve frame section referencelists');
        }
      );
  }
  ngOnDestroy(): void {
    console.log(' Frame Component - ngOnDestroy ' );
    this.subs.dispose();
  }

}



// WEBPACK FOOTER //
// /home/jenkins-agent/workspace/ng-labportal-prod-build/src/app/modify-order/frame/frame.component.ts